<template>
  <v-row justify="center" v-if="user">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <!-- LOADING OVERLAY -->
      <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Demande de coaching en ligne</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="close">Confirmer</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-stepper v-model="e6" vertical>
          <v-stepper-step :complete="e6 > 1" step="1">
            Informations générales
            <small>Présentez-vous a votre coach</small>
          </v-stepper-step>
          <!-- Stepper 1 -->
          <v-stepper-content step="1">
            <!-- Step 1 Form info generale-->
            <v-form v-model="isValidGInfo">
              <v-container>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="user.firstName"
                      label="Prénom"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="user.lastName"
                      label="Nom"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-combobox
                      :items="items"
                      label="Region"
                      v-model="user.country"
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-radio-group row v-model="user.gender">
                      <v-radio
                        :ripple="false"
                        label="Homme"
                        value="male"
                        off-icon="mdi-gender-male"
                        on-icon="mdi-gender-male"
                        color="blue"
                      ></v-radio>
                      <v-radio
                        :ripple="false"
                        label="Femme"
                        value="female"
                        off-icon="mdi-gender-female"
                        on-icon="mdi-gender-female"
                        color="pink"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <v-btn color="primary" @click="next(2)">Continuer</v-btn>
          </v-stepper-content>
          <!-- Step 2 Objectifs -->
          <v-stepper-step :complete="e6 > 2" step="2">
            Objectif
            <small>Présisez votre objectif</small>
          </v-stepper-step>

          <v-stepper-content step="2">
            <ObjectifCards @onSelected="selectObj" />
            <v-btn color="primary" @click="next(3)">Continue</v-btn>
            <v-btn text @click="e6 = 1">Revenir</v-btn>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 3" step="3">
            Paramétres
            <small>Aidez votre coach pour vous connaitre</small>
          </v-stepper-step>

          <v-stepper-content step="3">
            <!-- Step 3 body info -->
            <v-row>
              <v-col cols="12" md="6">
                <v-subheader class="pl-0">Votre taille</v-subheader>
                <v-slider
                  v-model="user.height"
                  max="218"
                  min="100"
                  thumb-size="24"
                  prepend-icon="$vuetify.measure"
                  thumb-label="always"
                ></v-slider>
              </v-col>
              <v-col cols="12" md="6">
                <v-subheader class="pl-0">Votre poids</v-subheader>
                <v-slider
                  v-model="user.weight"
                  max="300"
                  min="30"
                  thumb-size="24"
                  prepend-icon="$vuetify.scale"
                  thumb-label="always"
                ></v-slider>
              </v-col>
            </v-row>

            <v-btn color="primary" @click="next(4)">Continue</v-btn>
            <v-btn text @click="e6 = 2">Revenir</v-btn>
          </v-stepper-content>

          <v-stepper-step step="4">
            Première séance
            <small>Vous pouvez choisir votre première session</small>
          </v-stepper-step>
          <v-stepper-content step="4">
            <!-- Step 4 Form Contact -->
            <v-row>
              <v-col cols="12" md="6">
                <!-- <VueTimepicker
                      v-model="sessionDateTime"
                      placeholder="Commence à"
                      input-width="100%"
                      close-on-complete
                      advanced-keyboard
                      manual-input
                      auto-scroll
                    /> -->
                <DatePicker v-model="rdv" />
              </v-col>
            </v-row>
            <v-btn color="primary" @click="onSendForm">Envoyer</v-btn>
            <v-btn text @click="e6 = 3">Revenir</v-btn>
          </v-stepper-content>
        </v-stepper>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ObjectifCards from "@/components/dashboard/ObjectifCards";
import DatePicker from "@/components/DatePicker.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  props: ["dialog", "coachId", "isLive", "packId"],
  components: {
    ObjectifCards,
    VueTimepicker,
    DatePicker,
  },
  data() {
    return {
      isValidGInfo: false,
      isValidFitInfo: true,
      isValidContact: false,
      selectedObjectif: null,
      height: 120,
      weight: 40,
      name: "",
      rdv: null,
      sessionDateTime: null,
      phoneRules: [
        (v) => !!v || "Nurémo est requis",
        (v) => v.length < 8 || "Numéro 8 chiffres",
        (v) => v.length > 8 || "Numéro 8 chiffres",
      ],
      items: [
        "Ariana",
        "Béja",
        "Ben Arous",
        "Bizerte",
        "Gabès",
        "Gafsa",
        "Jendouba",
        "Kairouan",
        "Kasserine",
        "Kebili",
        "Kef",
        "Mahdia",
        "Manouba",
        "Medenine",
        "Monastir",
        "Nabeul",
        "Sfax",
        "Sidi Bouzid",
        "Siliana",
        "Sousse",
        "Tataouine",
        "Tozeur",
        "Tunis",
        "Zaghouan",
      ],
      age: 0,
      ageRules: [(v) => v > 0 || "L'age doit être valide"],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail est requis",
        (v) => /.+@.+/.test(v) || "E-mail doit être valide",
      ],
      notifications: false,
      sound: true,
      widgets: false,
      e6: 1,
    };
  },
  computed: {
    ...mapGetters(["user", "loading"]),
  },
  methods: {
    next(v) {
      if (this.checkForm(v)) this.e6 = v;
    },
    checkForm(v) {
      switch (v) {
        case 2:
          return this.isValidGInfo;
          break;
        case 3:
          return this.selectedObjectif !== null;
          break;
        case 4:
          return this.isValidFitInfo;
          break;
        // case 4:
        //   return this.isValidContact;
        //   break;
      }
    },
    close() {
      this.$emit("close-dialog");
    },
    selectObj(v) {
      this.selectedObjectif = v;
    },
    ...mapActions({
      onBookCoach: "bookCoach",
      requestLiveCoach: "requestLiveCoach",
      updateUser: "updateUser",
    }),
    async onSendForm() {
      await this.updateUser(this.user);
      if (this.isLive)
        this.requestLiveCoach({
          user: this.user,
          coachId: this.coachId,
          objectif: this.selectedObjectif,
          packId: this.packId,
          firstSession: this.rdv,
        });
      else
        this.onBookCoach({
          user: this.user,
          coachId: this.coachId,
          objectif: this.selectedObjectif,
          packId: this.packId,
          firstSession: this.rdv,
        });
      this.close();
    },
  },
};
</script>